module.exports = "//docs.gtimg.com/slide/img/page/toc/common/meeting-room-manager/img/ent_logo-48ee15.png";